module.exports = __webpack_public_path__ + "assets/3c7310f554e4414edebed240a9b55992.jpg";